<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BM0nLS/tc-custom/9781952871214.jpg?1697203703047" alt="This image is the cover for the book 60 Days of Pleasure, Days of Pleasure Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">60 Days of Pleasure, Days of Pleasure Series
      </h1>
      <p class="bookDescription body article font2">
        <b> Determined to give Alicia Mitchell the love that she longs for, NBA-star Dallas Avery whisks her away on exciting adventures around the world.</b><br/><br/>Dallas let his heart dictate their journey to Seattle and allows the Emerald City to work its magic on Alicia. Until civil unrest involving the indigenous people collides with a dirty politician’s plans to use city funds to cover personal debts.  A chance meeting with Yuma, a tribal chief’s son, creates an opportunity for Dallas to make a difference for those whose voices have been silenced. When an altercation with the police develops after Dallas and Alicia assist a homeless woman, Yuma’s tribe is forced to shift gears and protect the couple.<br/><br/>Can Dallas keep the love of his life safe, and will the civil unrest drive a permanent wedge between them?<br/><br/><b>ABOUT THE DAYS OF PLEASURE SERIES</b><br/>Each Pleasures book is a standalone, NO cliffhangers<br/><br/>USA TODAY, and National Bestselling Authors take you on amazing journey with NBA Basketball Star, Dallas Avery, and Alicia Mitchell, a woman who is as mysterious as she is beautiful.<br/>Follow this unlikely couple as they travel to exotic places such as Paris, Durabia, Caribbean, Scotland and many others. Each story embroils them in a new set of challenges and adventure as they navigate their way to love.<br/><br/>Book 1–10 Days of Pleasure by Stephanie M. Freeman<br/>Book 2–20 Days of Pleasure by J. L. Campbell<br/>Book 3–30 Days of Pleasure by Sierra Kay<br/>Book 4–40 Days of Pleasure by Martha Kennerson and Stephanie M. Freeman<br/>Book 5–50 Days of Pleasure by Anita L. Roseboro and Michelle D. Rayford<br/>Book 6–60 Days of Pleasure by Vanessa<br/>Book 7–70 Days of Pleasure by Christine Pauls<br/>Book 8–80 Days of Pleasure by Aiken Ponder<br/>Book 9–90 Days of Pleasure by Marie L. McKenzie and Naleighna Kai<br/>Book 10—Open Door Marriage by Naleighna Kai
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vanessa Howard
      </h2>
      
      <p class="authorDescription body article">Vanessa Howard, affectionately known as Dr. V, is a #1 Amazon Bestseller author and an award-winning educator. She started her writing career creating stories for children in her classroom. Her high-interest reading materials were instrumental in helping students develop a love for reading. Dr. V has written a memoir, From the Projects to a Ph.D.: A View from the Other Side of America, to provide awareness of cultural biases and share strategies to effectively communicate across cultures. Her other projects include Christian, contemporary, women’s fiction, and non-fiction books that focus on relationships and women’s issues. Currently, she teaches at the university level and is a nationwide speaker and literacy trainer. In her spare time, she likes to sew and spend time with her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macro Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ba85bfbc